export const NAMESPACE = 'USERS_SEARCH/';

export const SET_SEARCH_TYPE = NAMESPACE + 'SET_SEARCH_TYPE';
export const SET_SEARCH_QUERY = NAMESPACE + 'SET_SEARCH_QUERY';
export const SET_AGE_MIN = NAMESPACE + 'SET_AGE_MIN';
export const SET_AGE_MAX = NAMESPACE + 'SET_AGE_MAX';
export const SET_SELECTED_COUNTRY = NAMESPACE + 'SET_SELECTED_COUNTRY';
export const SET_SELECTED_CITY = NAMESPACE + 'SET_SELECTED_CITY';
export const SET_GENDER = NAMESPACE + 'SET_GENDER';
